var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row pt-3" }, [
      _c(
        "div",
        { staticClass: "col-3" },
        [
          _c("div", { staticClass: "select-wrap" }, [
            _c("label", [_vm._v("Carrier name")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.carrier.name,
                  expression: "carrier.name"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.carrier.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.carrier, "name", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("error-field", { attrs: { errors: _vm.errors, field: "name" } })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.$_can("carriers.percentages.show")
      ? _c("div", { staticClass: "row mb-3 mt-3" }, [
          _c("div", { staticClass: "col-2 pr-1" }, [
            _c("div", { staticClass: "select-wrap amount-wrap" }, [
              _c("label", [_vm._v("Fee")]),
              _vm._v(" "),
              _c("span", { staticClass: "dollar" }, [_vm._v("$")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.percentages.fee,
                    expression: "percentages.fee"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: "Fee",
                  disabled: !_vm.$_can("carriers.percentages.store")
                },
                domProps: { value: _vm.percentages.fee },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.percentages, "fee", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-2 pr-1" }, [
            _c("div", { staticClass: "select-wrap amount-wrap" }, [
              _c("label", [_vm._v("Percent")]),
              _vm._v(" "),
              _c("span", { staticClass: "percent" }, [_vm._v("%")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.percentages.percent,
                    expression: "percentages.percent"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: "Percent",
                  disabled: !_vm.$_can("carriers.percentages.store")
                },
                domProps: { value: _vm.percentages.percent },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.percentages, "percent", $event.target.value)
                  }
                }
              })
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row mx-0" }, [
      _c("div", { staticClass: "col py-3 pl-0 text-left" }, [
        _vm.$_can("carriers.destroy")
          ? _c(
              "button",
              {
                staticClass: "btn btn-delete",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.deleteCarrier(_vm.carrier.id)
                  }
                }
              },
              [_vm._v("\n        Delete\n      ")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col py-3 pr-0 text-right" }, [
        _vm.$_can("carriers.update")
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary ld-ext-right",
                class: _vm.loadingButton ? "running" : "",
                attrs: { disabled: _vm.loadingButton },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  }
                }
              },
              [
                _vm._v("\n        Save\n        "),
                _c("div", { staticClass: "ld ld-ball ld-flip" })
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f87b02c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f87b02c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carriers/CarriersInfo.vue
// module id = null
// module chunks = 